import { ServiceTypeResidualPercentTableStore } from './service-type-residual-percent-table.store';
import { fb, routeParams, translate } from '../../../../../modules/shared/shared.global-service';
import { Component, computed, inject, viewChild } from '@angular/core';
import { getSocialServiceResidualPercentsFrag } from './service-type-residual-percent-table.query';
import { dateField, textColumn } from '../../../../../modules/shared/components/kit/table/table.fields';
import { FilterBuilder } from '../../../../../modules/content/helper/filter.builder';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import { ConfirmBuilder } from '../../../../../modules/shared/service/confirm.builder';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { SwitchInputComponent } from '../../../../kit/input/switch-input/switch-input.component';
import { changeSignal } from '../../../../../utils/form.utils';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import {
    SocialServiceResidualPercentObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-residual-percent.object';
import {
    ServiceTypeResidualPercentUpsertDialogComponent,
} from '../service-type-residual-percent-upsert-dialog/service-type-residual-percent-upsert-dialog.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-service-type-residual-percent-table',
    templateUrl: './service-type-residual-percent-table.component.html',
    styleUrl: './service-type-residual-percent-table.component.scss',
    providers: [ServiceTypeResidualPercentTableStore],
    imports: [
        SwitchInputComponent,
        TableComponent,
        PrimeTemplate,
    ],
})
export class ServiceTypeResidualPercentTableComponent {

    public readonly store = inject(ServiceTypeResidualPercentTableStore);
    public readonly dialogService = inject(BaseDialogService);
    public readonly confirm = inject(ConfirmBuilder);

    protected readonly residualPercentTable = viewChild<TableComponent>('residualPercentTable');

    protected form = fb.group({
        residualPercentActiveOnly: fb.control(true),
    });

    protected residualPercentActiveChange = changeSignal(this.form.controls.residualPercentActiveOnly);
    protected additionalFilter = computed(() => {
        const builder = new FilterBuilder();
        builder.where('serviceTypeId', routeParams.serviceTypeId());
        if (this.residualPercentActiveChange()) {
            builder.validByNow();
        }

        return builder.filter().filter;
    });

    protected prefix = 'serviceType.residualPercent.';

    protected columns = [
        textColumn('percent'),
        dateField('validFrom'),
        dateField('validTo'),
    ];

    protected readonly getSocialServiceResidualPercentsFrag = getSocialServiceResidualPercentsFrag;

    protected openDetail(item: SocialServiceResidualPercentObject | null = null): void {
        this.dialogService.open(
            ServiceTypeResidualPercentUpsertDialogComponent,
            {
                header: translate.instant('serviceType.residualPercent.label'),
                data: { residualPercent: item },
                styleClass: 'p-dialog-width-60',
                focusOnShow: false,
            },
        ).onClose.subscribe((it) => {
            if (it) {
                this.residualPercentTable()?.reload();
            }
        });
    }

    protected async delete(event: any): Promise<void> {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteSocialServiceResidualPercent({ id: event.item.id });
                contentGlobalSuccess.next('common.deleted');
                this.residualPercentTable()?.reload();
            },
            event,
        );
    }

}
